import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-andriodpopup',
  templateUrl: './andriodpopup.component.html',
  styleUrls: ['./andriodpopup.component.css']
})
export class AndriodpopupComponent implements OnInit {
  @Input() message: any;
  @Input() android: boolean;
  constructor(public dialogRef: MatDialogRef<AndriodpopupComponent>, public router: Router) {
    //////console.log("hello")
  }

  ngOnInit() {
  }

}
